import React from 'react';
import BottomNav from '../components/BottomNav';

const WealthAdvisory = () => {
  return (
    <div className="page-container">
      <div className="page-wrapper">
        <h1 className="page-title">Global Wealth Advisory</h1>
        <div className="underline"></div>
        <p className="page-subtitle">Strategic Financial Planning & Management</p>
        
        <div className="card">
          <p>
            Strategic financial planning and wealth management services from industry experts. 
            Tailored solutions for sophisticated investors and high-net-worth families.
          </p>
          
          <div className="service-features">
            <div className="feature-item">
              <h3>Portfolio Strategy</h3>
              <p>Comprehensive investment optimization</p>
            </div>
            <div className="feature-item">
              <h3>Estate Planning</h3>
              <p>Wealth preservation and succession strategies</p>
            </div>
            <div className="feature-item">
              <h3>Global Investments</h3>
              <p>International opportunities and diversification</p>
            </div>
          </div>
        </div>
      </div>
      
      <BottomNav />
    </div>
  );
};

export default WealthAdvisory;
